import { render } from "./view.vue?vue&type=template&id=74881f10&ts=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Plays/view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74881f10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74881f10', __exports__)) {
    api.reload('74881f10', __exports__)
  }
  
  module.hot.accept("./view.vue?vue&type=template&id=74881f10&ts=true", () => {
    api.rerender('74881f10', render)
  })

}


export default __exports__